import React, {useMemo, useState} from 'react'
import Pagination from '../Pagination';
import {Link, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import Pusher from "pusher-js";
import {updateStateJurnal} from '../../features/jurnalSlice';
import {useEffect} from 'react';
import useImgError from '../../utils/imgErrorValidation';
import DisplayKategoriList from '../DisplayKategoriList';
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import IndicatorValid from './IndicatorValid';
import RowTanggal from './RowTanggal';
import RowJam from './RowJam';
import ColumnMasukAndKeluar from './ColumnMasukAndKeluar';
import ColumnSuksesAndAbsen from './ColumnSuksesAndAbsen';
import ColumnIzin from './ColumnIzin';

let PageSize = 10;

function Table() {
    const dispatch = useDispatch()
    let [searchParams] = useSearchParams();

    const {
        jurnalBelumDivalidasi,
        jurnalTidakValid,
        jurnalValid,

        currentPage,
        keterangan,
        urutan,
        loading
    } = useSelector(state => state.jurnal)

    useEffect(() => {
        dayjs.locale('id');
    }, [])

    useEffect(() => {
        const currentPageParams = searchParams.get('paginate') ? searchParams.get('paginate') : 1;
        dispatch(updateStateJurnal({name: 'currentPage', value: parseInt(currentPageParams)}))
    }, [searchParams, dispatch]);


    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;

        let selectedData = [];

        if (keterangan === 'Belum Divalidasi') {
            selectedData = jurnalBelumDivalidasi;
        } else if (keterangan === 'Tidak Valid') {
            selectedData = jurnalTidakValid;
        } else if (keterangan === 'Valid') {
            selectedData = jurnalValid;
        }

        console.log(urutan)
        if (urutan === 'Penugasan') {
            selectedData = selectedData.filter(item => item.user.tipe_jurnal === 'Penugasan');
        } else if (urutan === 'Mengajar') {
            selectedData = selectedData.filter(item => item.user.tipe_jurnal === 'Mengajar');
        }





        return selectedData.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, keterangan, jurnalBelumDivalidasi, jurnalTidakValid, jurnalValid]);


    function validasi(tipe){
        if(tipe === "Tidak Valid"){
            return "#FF4530"
        }else if(tipe === "Valid"){
            return "#277FFE"
        }else {
            return "#9B9B9B"
        }
    }

    return (
        <>
            <table className='table'>
                <thead>
                <tr className='column'>

                    <th className='th-name'>Nama</th>
                    <th className='th-niy'>Tipe</th>
                    <th className='th-jabatan'>Mapel</th>
                    <th className='th-tanggal'>Tanggal</th>
                    <th className='th-tanggal'>Status</th>
                    <th className='th-action'>Action</th>
                </tr>
                </thead>

                <tbody>
                {currentTableData.length === 0 ? (
                    <tr className='loading-table'>
                        <td>Data tidak ditemukan</td>
                    </tr>
                ) : currentTableData?.map((item, key) => {
                    return (
                        <tr key={key}>
                            <td className='row-img'>

                                <img src={item?.user?.link_foto} onError={useImgError} alt={item.user?.nama} />
                                {item?.user?.nama}
                            </td>

                            <td>{item?.user?.tipe_jurnal}</td>
                            <td>{item?.user?.mapel}</td>
                            <td>{item?.tanggal_jurnal}</td>
                            <td style={{color: validasi(item?.status)}}>{item?.status}</td>


                            <td className='wrapper__btn__detail'>
                                <Link
                                    className='btn-detail'
                                    to={
                                        `/jurnalguru/detail/${item?.id}`
                                    }
                                >
                                    Detail
                                </Link>
                            </td>
                        </tr>
                    )
                })
                }
                </tbody>

            </table>

            {!loading &&
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={
                        keterangan === 'Belum Divalidasi' ? jurnalBelumDivalidasi?.length :
                            keterangan === 'Valid' ? jurnalValid?.length :
                                jurnalTidakValid?.length
                    }
                    pageSize={PageSize}
                    onPageChange={
                        page => dispatch(updateStateJurnal({name: 'currentPage', value: page}))}
                />
            }
        </>
    )
}

export default Table